<div class="editBttn">
  <label *ngIf="label">
    {{ label }}
  </label>
  <div class="position-relative bg-secondary p-2 rounded" style="min-height: 36px;">  
    <ng-container *ngFor="let item of items">
      <span [title]="item.longName" class="badge bg-primary mr-1">
        {{ item.longName }}
      </span>
    </ng-container>
  </div>
</div>
